// this comes from the webpack build now
export const gitBranch = process.env.GIT_BRANCH || '';
export const gitSha = process.env.GIT_SHA || '';
export const gitData = gitBranch && gitSha ? `${gitBranch}@${gitSha}` : 'unknown';

export default {
  gitBranch,
  gitSha,
  gitData,
};
